import React, {ReactNode, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import EEGChildSummaryFrontLobeDevelopmentAPI from 'components/molcules/N1SummaryReport/EEGChild/EEGSummaryFrontLobeDevelopmentAPI'
import EEGChildSummaryInformationProcessingSpeedAPI from 'components/molcules/N1SummaryReport/EEGChild/EEGSummaryInformationProcessSpeedAPI'
import EEGSummaryAlphaBandDevelopmentAPI from 'components/molcules/N1SummaryReport/EEGChild/EEGSummaryAlphaBandDevelopmentAPI'
import EEGSummaryBrainBalanceDevelopmentAPI from 'components/molcules/N1SummaryReport/EEGChild/EEGSummaryBrainBalanceDevelopmentAPI'
import EEGSummaryBrainAgeDevelopmentAPI from 'components/molcules/N1SummaryReport/EEGChild/EEGSummaryBrainAgeDevelopmentAPI'
// import EEGSummaryBrain3DAPI from 'components/molcules/N1SummaryReport/EEG/EEGSummaryBrain3dAPI'
// import EEGSummaryOpinionAPI from 'components/molcules/N1SummaryReport/EEG/EEGSummaryOpnionAPI'
// import EEGSummaryLobeAPI from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryLobeAPI'
import EEGSummaryBrain3DAPI from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryBrain3dAPI'
import EEGSummaryLobeAPI from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryLobeAPI'
import EEGSummaryOpinionAPI from 'components/molcules/ProfitSummaryReport/EEG/EEGSummaryOpnionAPI'
import RoiComponentAPI from 'components/molcules/Report/RoiComponentAPI'
import useLanguage from 'features/languageReport/useLanguage'
import {getLanguage} from 'api/storageApi'
import {Lobe, Roi} from 'api/analysisApi'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'

interface EEGChildSummaryProps {
  CustomerCard?: ReactNode
  frontalLobeDevelopmentGraph_image?: string
  frontalLobeDevelopmentColorbarImage?: string
  informationProcessingSpeedGraphImage?: string
  frontalLobeDevelopment: {
    sensor_tbr_cz: number
    percentile?: number
    // normal_range_min: number
    // normal_range_max: number
  }
  informationProcessingSpeed: {
    occipital_alpha_peak_freq: number
    percentile: number
    // normal_range_min: number
    // normal_range_max: number
  }
  alphaBandDevelopment: {
    ec_alpha_proportion: number
    eo_alpha_proportion: number
    ec_alpha_proportion_normal: number
    eo_alpha_proportion_normal: number

    ec_alpha_proportion_percentile: number
    eo_alpha_proportion_percentile: number
  }
  alphaBandDevelopmentBarGraphImage: string
  alphaBandDevelopmentLineGraphImage: string
  brainBalance: {
    LH: number
    RH: number
  }
  brainBalance3dImage: string
  brainBalanceImage: string
  brainAge: {
    avg: number
    by_lobe: Lobe
    subject_age: number
  }
  lobe: Lobe
  reportType: ReportType
  roi: Roi
  brainAgeGraphImage: string
  contourImage?: string
  threeDimensionImage: string
  total: number
  isSummary?: boolean
}

export default function NoneChildProfitSummaryAPI(props: EEGChildSummaryProps) {
  const {
    frontalLobeDevelopment,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    frontalLobeDevelopmentGraph_image,
    frontalLobeDevelopmentColorbarImage,
    informationProcessingSpeedGraphImage,
    informationProcessingSpeed,
    alphaBandDevelopment,
    alphaBandDevelopmentBarGraphImage,
    alphaBandDevelopmentLineGraphImage,
    brainBalance,
    brainBalance3dImage,
    brainBalanceImage,
    brainAgeGraphImage,
    brainAge,
    threeDimensionImage,
    contourImage,
    reportType,
    lobe,
    roi,
    total,
    CustomerCard,
    isSummary,
  } = props
  const classes = useStyles()
  const {t} = useTranslation()
  const {textEegAPI} = useLanguage('eeg')

  const [isShowSummaryChild, setIsShowSummaryChild] = useState<boolean>(false)
  const [isEmptyReport, setIsEmptyReport] = useState<boolean>(false)
  const lang = getLanguage()

  useEffect(() => {
    if (lang && lang === 'ko') setIsShowSummaryChild(true)
    else setIsShowSummaryChild(true)
  }, [lang])

  useEffect(() => {
    const isEmpty =
      !isShowSummaryChild && !lobe && !threeDimensionImage && !contourImage
    setIsEmptyReport(isEmpty)
  }, [isShowSummaryChild])

  return (
    <div className={classes.root}>
      {CustomerCard && CustomerCard}
      {isShowSummaryChild && (
        <>
          {frontalLobeDevelopment && (
            <EEGChildSummaryFrontLobeDevelopmentAPI
              frontalLobeDevelopmentGraphImage={
                frontalLobeDevelopmentGraph_image
              }
              frontalLobeDevelopmentColorbarImage={
                frontalLobeDevelopmentColorbarImage
              }
              score={frontalLobeDevelopment.sensor_tbr_cz ?? 0}
              percentile={frontalLobeDevelopment.percentile ?? 0}
              // minRange={frontalLobeDevelopment.normal_range_min ?? 0}
              // maxRange={frontalLobeDevelopment.normal_range_max ?? 0}
              isSummary={isSummary}
            />
          )}
          {informationProcessingSpeed && (
            <EEGChildSummaryInformationProcessingSpeedAPI
              informationProcessingSpeedGraphImage={
                informationProcessingSpeedGraphImage
              }
              score={informationProcessingSpeed.occipital_alpha_peak_freq ?? 0}
              percentile={informationProcessingSpeed.percentile ?? 0}
              // minRange={informationProcessingSpeed.normal_range_min ?? 0}
              // maxRange={informationProcessingSpeed.normal_range_max ?? 0}
              isSummary={isSummary}
            />
          )}
          {alphaBandDevelopment && (
            <EEGSummaryAlphaBandDevelopmentAPI
              alphaBandDevelopmentBarGraphImage={
                alphaBandDevelopmentBarGraphImage
              }
              alphaBandDevelopmentLineGraphImage={
                alphaBandDevelopmentLineGraphImage
              }
              eo_alpha_proportion_percentile={
                alphaBandDevelopment.eo_alpha_proportion_percentile
              }
              ec_alpha_proportion_percentile={
                alphaBandDevelopment.ec_alpha_proportion_percentile
              }
              isSummary={isSummary}
            />
          )}
          {brainBalance && (
            <EEGSummaryBrainBalanceDevelopmentAPI
              brainBalance3dImage={brainBalance3dImage}
              brainBalanceImage={brainBalanceImage}
              LH={brainBalance.LH ?? 0}
              RH={brainBalance.RH ?? 0}
              isSummary={isSummary}
            />
          )}
          {brainAge && (
            <EEGSummaryBrainAgeDevelopmentAPI
              brainAgeGraphImage={brainAgeGraphImage}
              avg={brainAge.avg ?? 0}
              age={brainAge.subject_age ?? 0}
              lobe={brainAge.by_lobe}
              isSummary={isSummary}
            />
          )}
        </>
      )}
      {/* {lobe !== null && lobe !== undefined && (
        <EEGSummaryLobeAPI
          index={brainBalance == null || !isShowSummaryChild ? 1 : 6}
          lobe={lobe}
          isSummary={isSummary}
        />
      )}

      {threeDimensionImage && (
        <EEGSummaryBrain3DAPI
          index={brainBalance == null || !isShowSummaryChild ? 2 : 7}
          threeDimensionImage={threeDimensionImage}
          isSummary={isSummary}
        />
      )}
      {contourImage && (
        <EEGSummaryOpinionAPI
          index={brainBalance == null || !isShowSummaryChild ? 3 : 8}
          score={total ?? 0}
          contourImage={contourImage}
          isSummary={isSummary}
        />
      )} */}
      <EEGSummaryBrain3DAPI
        index={1}
        threeDimensionImage={threeDimensionImage}
        isSummary={isSummary}
      />
      {lobe !== null && lobe !== undefined && (
        <EEGSummaryLobeAPI index={2} lobe={lobe} isSummary={isSummary} />
      )}
      <EEGSummaryOpinionAPI
        index={3}
        score={total}
        contourImage={contourImage}
        isSummary={isSummary}
      />
      {lobe != null &&
        lobe !== undefined &&
        roi != null &&
        roi !== undefined &&
        reportType === 'P2' && <RoiComponentAPI roi={roi} lobe={lobe} />}
      {isEmptyReport && (
        <p style={{textAlign: 'center', color: 'red'}}>
          {t('IResultNotProvided')}
        </p>
      )}
      <div className='Warning'>{`${textEegAPI?.footer[0]} ${textEegAPI?.footer[1]}`}</div>
    </div>
  )
}
